import React from 'react'
import PropTypes from 'prop-types'
import { PositionalMediaButton, PositionalMediaPlayer } from '../../../containers/positionalMedia'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const PositionalMediaWrapper = ({ positionalMedia, scene, camera, renderer, contextType }) => (
    <div>
        {positionalMedia.map(id => {
            return (
                <PositionalMediaPlayer key={id} id={id} contextType={contextType}>
                    <PositionalMediaButton
                        id={id}
                        scene={scene}
                        camera={camera}
                        renderer={renderer}
                        contextType={contextType}
                    />
                </PositionalMediaPlayer>
            )
        })}
    </div>
)

PositionalMediaWrapper.propTypes = {
    positionalMedia: PropTypes.array,
}

PositionalMediaWrapper.defaultProps = {
    positionalMedia: [],
}

export default compose(pure)(PositionalMediaWrapper)
